const colors = {
  cerulean: '#04649B',
};

export default colors;
